import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TuiDataList, TuiScrollbar, TuiScrollable, TuiDropdown, TuiButton, TuiHint } from '@taiga-ui/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@src/app/components';
import { ListModule } from '@src/app/shared/list';
import { SharedModule } from '@src/app/shared';
import { GroupInfoModule } from '@src/app/modules/group-info';
import { IconModule } from '@src/app/modules/icon';
import { ActionsModule } from '@src/app/modules/actions';
import { ChatService, ChatFilesService, ChatManagementService } from '@src/api-messenger';

import { InternalMessengerComponent } from './internal-messenger.component';
import { ChatModule } from './chat';
import { SettingsButtonModule } from './settings';
import { ConnectionStateComponent } from './connection-state';

@NgModule({
  declarations: [InternalMessengerComponent, ConnectionStateComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgxPermissionsModule,
    TranslateModule,
    ComponentsModule,
    ListModule,
    SharedModule,
    GroupInfoModule,
    RouterModule,
    IconModule,
    ChatModule,
    ActionsModule,
    TuiButton,
    ...TuiDropdown,
    ...TuiDataList,
    ...TuiHint,
    TuiScrollbar,
    TuiScrollable,
    SettingsButtonModule,
  ],
  exports: [InternalMessengerComponent, ConnectionStateComponent],
  providers: [ChatService, ChatFilesService, ChatManagementService],
})
export class InternalMessengerModule {}
